import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ClipboardCopy, Copy } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface CopyButtonProps {
  textToCopy: string;
}

export function CopyButtonTooltip({
  textToCopy = "Default text to copy",
}: CopyButtonProps) {
  const [showTooltip, setShowTooltip] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 2000); // Hide tooltip after 2 seconds
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <TooltipProvider>
      <Tooltip open={showTooltip}>
        <TooltipTrigger asChild>
          <Button
            onClick={copyToClipboard}
            variant="secondary"
            // size="icon"
            size="sm"
            // className="w-10 h-10"
          >
            <Copy className="h-4 w-4" />
            {/* <ClipboardCopy className="h-4 w-4" /> */}
            Copy
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Copied!</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
